<mat-card class="platform-card">
  <mat-card-header>
    <mat-card-title>{{ platform.sub_platform }}</mat-card-title>
    <mat-card-subtitle>
      <span class="status-badge"
        [class]="'status-' + (platform.current_status ? platform.current_status.toLowerCase().replace(' ', '-') : '')">
        {{ platform.current_status }}
      </span>
      <span class="priority-badge" [class]="'priority-' + (platform.priority ? platform.priority.toLowerCase() : '')">
        {{ platform.priority }}
      </span>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <!-- Specific Issue -->
    <div class="specific-issue">
      <h4>Issue:</h4>
      <p>{{ platform.specific_issue }}</p>
    </div>

    <!-- Improvement Needed -->
    <div class="improvement-needed">
      <h4>Improvement Needed:</h4>
      <p>{{ platform.improvement_needed }}</p>
    </div>

    <!-- Estimated Impact -->
    <div class="estimated-impact">
      <h4>Expected Impact:</h4>
      <p class="impact-text">{{ platform.estimated_impact }}</p>
    </div>

    <!-- Generate Button -->
    <div class="generate-section" *ngIf="platform.ready_to_generate">
      <button mat-raised-button color="primary" class="generate-button" (click)="onGenerateClick()">
        <mat-icon>create</mat-icon>
        Generate Sample Template
      </button>
    </div>
  </mat-card-content>
</mat-card>
